import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import CustomDropdownFilter from 'src/components/custom-cells/CustomDropdownFilter';

const options = [
  { text: 'OFF', operator: 'OFF' },
  { text: 'Required', operator: 'Required' },
  { text: 'Exempt', operator: 'Exempt' },
];
export const GLCodeApprovalFilterCell = (props: GridColumnMenuProps) => (
  <CustomDropdownFilter {...props} option={options} />
);
